import { render } from "./MaterialsLinksSdtTable.vue?vue&type=template&id=9c466638&scoped=true"
import script from "./MaterialsLinksSdtTable.vue?vue&type=script&lang=js"
export * from "./MaterialsLinksSdtTable.vue?vue&type=script&lang=js"

import "./MaterialsLinksSdtTable.vue?vue&type=style&index=0&id=9c466638&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c466638"]])

export default __exports__